import { UserManagerSettings } from 'oidc-client';
import {
  lassoProductionConfiguration,
  lassoStagingConfiguration,
} from '@amzn/dots-core-ui';

export interface Environment {
  hosts: string[];
  storageApiUrl: string;
  userManagerSettings: UserManagerSettings;
}

const environments: Environment[] = [
  {
    // Alpha
    hosts: [
      'localhost',
      'akutota.aka.corp.amazon.com',
      'storage-alpha.dots.lab126.a2z.com',
    ],
    storageApiUrl: 'https://api.storage-beta.dots.lab126.a2z.com',
    // storageApiUrl: 'https://localhost:3000/api/v2',
    userManagerSettings: lassoStagingConfiguration,
  },
  {
    // Beta
    hosts: [
      'localhost',
      'akutota.aka.corp.amazon.com',
      'yangaar.aka.corp.amazon.com',
      'tools-beta.dots.lab126.a2z.com',
      'storage-beta.dots.lab126.a2z.com',
    ],
    storageApiUrl: 'https://api.storage-beta.dots.lab126.a2z.com',
    // storageApiUrl: 'http://localhost:5180/api/v4',
    userManagerSettings: lassoStagingConfiguration,
  },
  {
    // Gamma
    hosts: ['storage-gamma.dots.lab126.a2z.com'],
    storageApiUrl: 'https://api.storage-gamma.dots.lab126.a2z.com/api/v2',
    userManagerSettings: lassoStagingConfiguration,
  },
  {
    // Prod
    hosts: ['tools.dots.lab126.a2z.com', 'storage.dots.lab126.a2z.com'],
    storageApiUrl: 'https://api.storage.dots.lab126.a2z.com',
    userManagerSettings: lassoProductionConfiguration,
  },
];

// hosts is a list of urls
const match = environments.filter(
  (config) => config.hosts.indexOf(window.location.hostname) > -1
);
if (match.length === 0) {
  throw new Error(`${window.location.hostname} is not configured`);
}

export const [environment] = match;
